import type { ReactNode } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../charte';

/**
 * Page de travail ouverte par-dessus une rubrique (livret et résumé de la séance, évaluation) : bouton « Retour »
 * vers l'écran d'origine, titre, contenu pleine largeur et barre d'actions collée en bas (au-dessus de la barre
 * de navigation du téléphone).
 */
export function PageShell({
  eyebrow,
  title,
  subtitle,
  actions,
  onBack,
  footer,
  children,
}: {
  eyebrow?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  onBack: () => void;
  footer?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="space-y-5">
      <Button variant="ghost" size="sm" icon={ArrowLeft} onClick={onBack} className="-ml-2">
        Retour
      </Button>
      <header className="flex flex-wrap items-end justify-between gap-3">
        <div className="min-w-0">
          {eyebrow && <p className="text-eyebrow uppercase text-primary-600">{eyebrow}</p>}
          <h1 className="text-title-md text-heading sm:text-title-lg">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-secondary">{subtitle}</p>}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </header>
      {children}
      {footer && (
        <div className="bottom-above-nav sticky z-20 flex flex-wrap items-center gap-2 rounded-card bg-white/95 p-3 shadow-pop backdrop-blur">
          {footer}
        </div>
      )}
    </section>
  );
}
